<section id="overall">
  <section id="header">
    <nav
      class="navbar navbar-expand-lg navbar-dark bg-dark"
      data-aos="fade-down"
    >
      <div class="container">
        <a class="navbar-brand fw-bold" href="#">Smartfolio</a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav">
            <li class="nav-item me-3">
              <a class="nav-link" href="#home">Home</a>
            </li>
            <li class="nav-item me-3">
              <a class="nav-link" href="#about">About</a>
            </li>
            <li class="nav-item me-3">
              <a class="nav-link" href="#skills">Skills</a>
            </li>
            <li class="nav-item me-3">
              <a class="nav-link" href="#service">Service</a>
            </li>
            <li class="nav-item me-3">
              <a class="nav-link" href="#projects">Projects</a>
            </li>
            <li class="nav-item me-3">
              <a class="nav-link" href="#contact">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </section>
  <section id="home">
    <div class="container">
      <div class="wrapper">
        <div class="row align-items-center">
          <div class="col-lg-7 col-md-12 col-sm-12">
            <div
              class="text-work"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <h1>Hi, I'm <span class="myname">Gopinath</span></h1>
              <h2>Full-stack Developer</h2>
              <button class="btn-detail mt-2">
                <a href="#about"><span>More About Me</span></a>
              </button>
            </div>
          </div>
          <div class="col-lg-5 col-md-12 col-sm-12">
            <div
              class="vector-img"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <svg
                id="avatar-red"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 271 364"
                shape-rendering="geometricPrecision"
                text-rendering="geometricPrecision"
              >
                <defs>
                  <path
                    id="avatar-red-svgid_1_"
                    d="M107.800000,74.400000L142.900000,58.700000L178,43C178,43,212.400000,78.200000,160.800000,124.800000C122.600000,114.600000,107.800000,74.400000,107.800000,74.400000Z"
                    stroke-miterlimit="1"
                  />
                </defs>
                <path
                  id="avatar-red-path1"
                  d="M246.800000,124.500000C244.300000,114.200000,238.400000,103.500000,227.700000,96.100000C203.500000,79.400000,183.100000,88.400000,183.100000,88.400000C183.100000,88.400000,124.500000,101.400000,120.700000,121.200000C118.500000,132.400000,125.500000,144.100000,125.500000,144.100000L123.100000,186.400000L205.200000,219.500000L206,247.300000L113,247.300000C105.400000,247.300000,99.300000,252.500000,99.300000,258.900000L99.300000,262C99.300000,268.400000,105.400000,273.600000,113,273.600000L181.600000,273.600000L181.600000,332.400000L153.400000,341.800000C153.200000,341.800000,153,341.700000,152.800000,341.700000L140.800000,341.700000C137.500000,341.700000,134.800000,346.600000,134.800000,352.700000C134.800000,358.800000,137.500000,363.700000,140.800000,363.700000L152.800000,363.700000C156.100000,363.700000,158.800000,358.800000,158.800000,352.700000C158.800000,349.900000,158.200000,347.400000,157.300000,345.500000L180.400000,339.400000L176.300000,344L166.400000,344C163.400000,344,160.900000,348.500000,160.900000,354C160.900000,359.500000,163.300000,364,166.400000,364L177.300000,364L177.300000,364L177.300000,364C180.300000,364,182.700000,359.500000,182.700000,354C182.700000,350.400000,181.700000,347.300000,180.200000,345.600000L187.200000,338.700000L214.200000,345.900000C212.900000,347.700000,212.200000,349.900000,212.200000,352.300000C212.200000,358.500000,217.300000,363.600000,223.500000,363.600000C229.700000,363.600000,234.800000,358.500000,234.800000,352.300000C234.800000,346.100000,229.700000,341,223.500000,341C221.800000,341,220.100000,341.400000,218.700000,342.100000L188.700000,332.400000L188.700000,273.700000L228.800000,273.700000C236.400000,273.700000,242.500000,268.500000,242.500000,262.100000L242.500000,259C242.500000,253.600000,238.100000,249,232.100000,247.700000C236,247.700000,242.500000,246,245.900000,236.400000C258,201.500000,266.200000,151.300000,270.800000,125.500000C272.400000,116.400000,264.200000,114.600000,246.800000,124.500000L246.800000,124.500000Z"
                  fill="rgb(255,255,255)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <g
                  id="avatar-red-shoe_to"
                  transform="translate(43.423828,216.236328)"
                >
                  <g id="avatar-red-shoe_tr" transform="rotate(0)">
                    <g
                      id="avatar-red-shoe"
                      transform="translate(-43.423828,-216.236328)"
                    >
                      <path
                        id="avatar-red-path2"
                        d="M70.600000,222.700000C70.600000,222.700000,14.200000,261.400000,0.900000,224.900000C-4.900000,208.400000,17.700000,201.600000,17.700000,201.600000L61.800000,203.900000L70.600000,222.700000L70.600000,222.700000Z"
                        fill="rgb(255,74,87)"
                        stroke="none"
                        stroke-width="1"
                        stroke-miterlimit="1"
                      />
                      <path
                        id="avatar-red-path3"
                        d="M76.300000,219.500000C76.300000,219.500000,38.300000,237.100000,23.100000,237.200000C18.600000,237.200000,9.700000,233,6.400000,226.400000C1.200000,216.200000,8.300000,200.600000,21.800000,201.900000C44.600000,204.100000,51.100000,201.300000,51.100000,201.300000C51.100000,201.300000,67.900000,193.500000,73.200000,192C78.500000,190.500000,86.900000,207.100000,86.900000,207.100000L76.300000,219.500000L76.300000,219.500000Z"
                        fill="rgb(51,51,50)"
                        stroke="none"
                        stroke-width="1"
                        stroke-miterlimit="1"
                      />
                      <path
                        id="avatar-red-path4"
                        d="M19.700000,202.600000C19.700000,202.600000,27,204.900000,30.700000,214.400000C34.700000,224.500000,33.700000,232.500000,33.700000,232.500000C33.700000,232.500000,29.200000,235,25,234.200000C20.800000,233.400000,9.200000,229.800000,7.400000,220.500000C4.300000,205,19.700000,202.600000,19.700000,202.600000L19.700000,202.600000ZM34.200000,207.900000C38.700000,212.400000,40.200000,218.300000,40.100000,224.500000C40.100000,226.600000,43.300000,226.600000,43.400000,224.500000C43.500000,217.500000,41.700000,210.600000,36.600000,205.600000C35,204.100000,32.700000,206.400000,34.200000,207.900000L34.200000,207.900000ZM40.500000,207.200000C44.900000,211.100000,46.500000,216.300000,46.400000,222.100000C46.400000,224.200000,49.600000,224.200000,49.700000,222.100000C49.800000,215.600000,47.800000,209.300000,42.900000,204.900000C41.300000,203.500000,39,205.800000,40.500000,207.200000L40.500000,207.200000ZM46.900000,206.200000C51.200000,209.900000,52.900000,214.900000,52.800000,220.400000C52.800000,222.500000,56,222.500000,56.100000,220.400000C56.200000,214,54.200000,208,49.300000,203.900000C47.600000,202.500000,45.300000,204.800000,46.900000,206.200000Z"
                        fill="rgb(255,74,87)"
                        stroke="none"
                        stroke-width="1"
                        stroke-miterlimit="1"
                      />
                    </g>
                  </g>
                </g>
                <path
                  id="avatar-red-path5"
                  d="M107.400000,100.700000C109.200000,104.700000,114.900000,106,120.100000,103.700000L122,102.900000C127.300000,100.600000,130.100000,95.400000,128.300000,91.400000L124,81.800000C122.200000,77.800000,116.500000,76.500000,111.300000,78.800000L109.400000,79.600000C104.100000,81.900000,101.300000,87.100000,103.100000,91.100000L107.400000,100.700000L107.400000,100.700000Z"
                  fill="rgb(35,31,32)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path6"
                  d="M108.800000,96.700000C110.600000,100.700000,115.300000,102.500000,119.200000,100.700000L120.600000,100.100000C124.600000,98.300000,126.400000,93.700000,124.600000,89.700000L120.300000,80.100000C118.500000,76.100000,113.900000,74.300000,109.900000,76.100000L108.500000,76.700000C104.500000,78.500000,102.700000,83.100000,104.500000,87.100000L108.800000,96.700000L108.800000,96.700000Z"
                  fill="rgb(252,208,158)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path7"
                  d="M197.700000,60.400000C199.500000,64.400000,197.700000,69,193.700000,70.800000L192.300000,71.400000C188.300000,73.200000,183.700000,71.400000,181.900000,67.400000L177.600000,57.800000C175.800000,53.800000,177.600000,49.100000,181.600000,47.400000L183,46.800000C187,45,191.600000,46.800000,193.400000,50.800000L197.700000,60.400000L197.700000,60.400000Z"
                  fill="rgb(35,31,32)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path8"
                  d="M193.900000,58.700000C195.700000,62.700000,193.900000,67.300000,189.900000,69.100000L188.500000,69.700000C184.500000,71.500000,179.800000,69.700000,178.100000,65.700000L173.800000,56.100000C172,52.100000,173.800000,47.500000,177.800000,45.700000L179.200000,45.100000C183.200000,43.300000,187.800000,45.100000,189.600000,49.100000C189.600000,49.100000,193.900000,58.700000,193.900000,58.700000Z"
                  fill="rgb(252,208,158)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <g id="avatar-red-g1">
                  <path
                    id="avatar-red-a"
                    d="M107.800000,74.400000L142.900000,58.700000L178,43C178,43,212.400000,78.200000,160.800000,124.800000C122.600000,114.600000,107.800000,74.400000,107.800000,74.400000Z"
                    fill="rgb(252,208,158)"
                    stroke="none"
                    stroke-width="1"
                    stroke-miterlimit="1"
                  />
                </g>
                <g id="avatar-red-g2">
                  <g id="avatar-red-g3" clip-path="url(#avatar-red-svgid_2_)">
                    <path
                      id="avatar-red-path9"
                      d="M149.900000,127.500000C151.100000,130.300000,156.400000,130.600000,161.700000,128.300000C167,126,170.200000,121.800000,169,119C167.800000,116.200000,162.500000,115.900000,157.200000,118.200000C151.900000,120.600000,148.600000,124.700000,149.900000,127.500000Z"
                      fill="rgb(194,181,155)"
                      stroke="none"
                      stroke-width="1"
                      stroke-miterlimit="1"
                    />
                    <clipPath id="avatar-red-svgid_2_">
                      <use
                        id="avatar-red-use1"
                        width="0"
                        height="0"
                        xlink:href="#avatar-red-svgid_1_"
                        fill="rgb(0,0,0)"
                        stroke="none"
                        stroke-width="1"
                        stroke-miterlimit="1"
                      />
                    </clipPath>
                  </g>
                </g>
                <path
                  id="avatar-red-path10"
                  d="M140.300000,52.900000C125.400000,59.600000,113,69.200000,103.800000,80.400000L94.900000,60.400000C85.800000,39.900000,94.900000,15.900000,115.400000,6.700000L122.600000,3.500000C143.100000,-5.700000,167.100000,3.500000,176.300000,24L185.200000,44C170.600000,43.500000,155.100000,46.300000,140.300000,52.900000ZM116.300000,40.600000C132.400000,33.700000,167.200000,25.700000,182.900000,28.900000L183,28.900000L183,28.900000C184.200000,29.200000,184.700000,29.900000,184.800000,30.700000C189.200000,40.600000,192.400000,47.800000,196.900000,57.700000C197.900000,59.900000,195.200000,61.400000,192.800000,61.600000C125.400000,65.500000,111.700000,85.500000,111.700000,97.800000C111.700000,100.300000,107.100000,100.500000,106.100000,98.300000L99.300000,83.200000L94.800000,73.100000C93.200000,69.500000,100.900000,47.200000,116.300000,40.600000L116.300000,40.600000ZM144,80.500000L140,71.600000C139.100000,69.600000,140.400000,67.100000,142.800000,66L157.800000,59.300000C160.200000,58.200000,162.900000,59,163.800000,61L167.800000,69.900000C168.700000,71.900000,167.400000,74.400000,165,75.500000L150,82.200000C147.600000,83.300000,144.900000,82.500000,144,80.500000L144,80.500000ZM143.800000,68.200000C142.700000,68.700000,142,69.800000,142.400000,70.700000L146.400000,79.600000C146.800000,80.400000,148,80.700000,149.200000,80.200000L164.200000,73.500000C165.400000,73,166,71.900000,165.600000,71L161.600000,62.100000C161.200000,61.300000,160,61,158.800000,61.500000L143.800000,68.200000L143.800000,68.200000ZM114.100000,93.900000L110.100000,85C109.200000,83,110.500000,80.500000,112.900000,79.400000L127.900000,72.700000C130.300000,71.600000,133,72.400000,133.900000,74.400000L137.900000,83.300000C138.800000,85.300000,137.500000,87.800000,135.100000,88.900000L120.100000,95.600000C117.700000,96.600000,115,95.900000,114.100000,93.900000L114.100000,93.900000ZM113.900000,81.500000C112.800000,82,112.100000,83.100000,112.500000,84L116.500000,92.900000C116.900000,93.700000,118.100000,94,119.300000,93.500000L134.300000,86.800000C135.500000,86.300000,136.100000,85.200000,135.700000,84.300000L131.700000,75.400000C131.300000,74.600000,130.100000,74.300000,128.900000,74.800000L113.900000,81.500000L113.900000,81.500000ZM145.400000,70.400000C145.700000,71.200000,146.500000,71.600000,147.200000,71.300000L161.100000,65.100000C161.700000,64.800000,162,63.900000,161.600000,63.200000C161.300000,62.400000,160.500000,62,159.800000,62.300000L146,68.500000C145.300000,68.700000,145.100000,69.600000,145.400000,70.400000ZM156.300000,67.200000C157.300000,69.500000,156.600000,72.100000,154.700000,73C152.800000,73.900000,150.400000,72.700000,149.300000,70.300000L156.300000,67.200000L156.300000,67.200000ZM128.800000,77.800000C129.100000,78.600000,128.900000,79.400000,128.300000,79.700000L114.400000,85.900000C113.800000,86.200000,113,85.800000,112.600000,85C112.300000,84.200000,112.500000,83.400000,113.100000,83.100000L127,76.900000C127.700000,76.600000,128.500000,77,128.800000,77.800000ZM119.200000,83.800000C120.200000,86.100000,122.600000,87.300000,124.600000,86.500000C126.500000,85.600000,127.200000,83.100000,126.200000,80.700000L119.200000,83.800000ZM132.600000,75.200000L141.600000,71.200000L142.600000,73.400000L133.600000,77.400000L132.600000,75.200000Z"
                  fill="rgb(35,31,32)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path11"
                  d="M213.900000,144.900000L213.100000,173.500000L185.200000,170.700000L194.200000,189.200000L233.300000,193.100000L240.600000,149.800000C240.600000,149.800000,243.700000,144.300000,231.600000,140C216,134.400000,213.900000,144.900000,213.900000,144.900000L213.900000,144.900000Z"
                  fill="rgb(252,208,158)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path12"
                  d="M88.700000,201.600000L60.900000,147.700000C60.900000,147.700000,55.100000,139,60.900000,136.900000C66.700000,134.800000,162.900000,114.200000,162.900000,114.200000C162.900000,114.200000,171.800000,111.300000,175.800000,121C179.800000,130.600000,193.100000,179.100000,193.100000,179.100000L219,191.700000L179.300000,189L88.700000,201.600000L88.700000,201.600000Z"
                  fill="rgb(242,242,242)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path13"
                  d="M192.400000,180.600000C191.100000,179.900000,190,179.300000,189.300000,179.100000C163.900000,170.700000,101.800000,194.600000,74.100000,195.700000C65.700000,196,59.400000,202.600000,58.300000,215.600000C57.800000,221,66.400000,218.600000,76.500000,218.200000C78.800000,218.100000,82,218.300000,85.900000,218.500000C83.600000,222,81.800000,226.200000,81.300000,230.900000C79.500000,247,71.600000,330,71.600000,330L109.800000,330.300000L115,248.400000L161.400000,255.600000L195.700000,255.500000C195.700000,255.500000,211.300000,252.600000,231.400000,230.100000C248.700000,210.700000,204.700000,186.700000,192.400000,180.600000L192.400000,180.600000Z"
                  fill="rgb(35,31,32)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path14"
                  d="M80.600000,326.700000L77.300000,330.200000L75.600000,322.400000L73.600000,322.300000L75.300000,337.700000L82.800000,327.100000L80.600000,326.700000Z"
                  fill="rgb(202,203,208)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path15"
                  d="M108.400000,354.700000L111.500000,348L112.800000,340.900000L112.800000,334.400000L123.400000,321.100000L91.400000,314.500000L86.400000,328.100000L86.500000,327.900000L86.200000,328.100000L81.600000,326.600000L76,333.800000C76.800000,330.700000,76.900000,326.300000,73.700000,322.300000C75.100000,330.800000,64,337.600000,64,337.600000C48.400000,340.100000,28.400000,344.700000,28.700000,351.800000C29.100000,363.400000,31.800000,362.700000,31.800000,362.700000L108.900000,362.700000L108.100000,354.600000L108.400000,354.700000L108.400000,354.700000Z"
                  fill="rgb(51,51,50)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path16"
                  d="M48.500000,340.700000C48.500000,340.700000,64.800000,341.800000,68.800000,345.200000C72.800000,348.600000,72.800000,353.100000,72.800000,353.100000L28.800000,353.200000C28.800000,353.200000,26,346.100000,34.700000,344.100000C40,342.800000,48.500000,340.700000,48.500000,340.700000ZM112.200000,361.100000C112.200000,362.500000,111.200000,363.600000,110,363.600000L29.200000,363.600000C28,363.600000,27,362.500000,27,361.100000L27,355.600000C27,354.200000,28,353.100000,29.200000,353.100000L109.900000,353.100000C111.100000,353.100000,112.100000,354.200000,112.100000,355.600000L112.100000,361.100000Z"
                  fill="rgb(255,74,87)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path17"
                  d="M55.600000,356.300000L109.200000,356.300000L109.200000,357.300000L55.600000,357.300000L55.600000,356.300000Z"
                  fill="rgb(202,203,208)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path18"
                  d="M28.400000,352.100000L109.800000,352.100000L109.800000,353.100000L28.400000,353.100000L28.400000,352.100000Z"
                  fill="rgb(51,51,50)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path19"
                  d="M55.600000,359.800000L109.200000,359.800000L109.200000,360.800000L55.600000,360.800000L55.600000,359.800000ZM57.500000,340.300000C63.500000,338.600000,69.200000,340.700000,73.400000,344.500000C74.800000,345.800000,77,343.800000,75.600000,342.600000C70.600000,338.100000,63.700000,335.700000,56.700000,337.700000C54.800000,338.200000,55.600000,340.800000,57.500000,340.300000L57.500000,340.300000ZM64.400000,337.600000C67.200000,336.900000,69.700000,337,72.500000,337.700000C74.800000,338.300000,76.500000,339.800000,78.400000,341C80,342,81.500000,339.700000,80,338.700000C77.800000,337.300000,76,335.900000,73.400000,335.100000C70.200000,334.100000,66.900000,334.200000,63.700000,335C61.700000,335.500000,62.500000,338.100000,64.400000,337.600000L64.400000,337.600000ZM68.500000,334.900000C72.400000,333.200000,78.700000,334.600000,81.400000,337.600000C82.600000,339,85.300000,337.600000,84.100000,336.200000C80.300000,331.900000,72.600000,330.100000,66.900000,332.500000C65.100000,333.300000,66.700000,335.600000,68.500000,334.900000Z"
                  fill="rgb(255,74,87)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path20"
                  d="M109.300000,330.400000C107.900000,333.500000,104.900000,335.300000,102.700000,334.300000C100.500000,333.300000,99.800000,329.900000,101.200000,326.800000C102.600000,323.700000,105.600000,321.900000,107.800000,322.900000C110,323.900000,110.700000,327.300000,109.300000,330.400000Z"
                  fill="rgb(255,255,255)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <path
                  id="avatar-red-path21"
                  d="M185.100000,67.800000C185.100000,67.800000,197,84,197,91.300000C197,99.800000,191.300000,111.300000,176.900000,119.400000C171.100000,114.800000,171.100000,102.600000,171.100000,102.600000L185.100000,67.800000L185.100000,67.800000Z"
                  fill="rgb(252,208,158)"
                  stroke="none"
                  stroke-width="1"
                  stroke-miterlimit="1"
                />
                <image
                  id="avatar-red-image1"
                  width="1389"
                  height="1420"
                  xlink:href="./../assets/Icons/logo.png"
                  preserveAspectRatio="xMidYMid meet"
                  transform="matrix(0.01715596020222 0 0 0.01571924053133 112.85769653320313 149.52929687500000)"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="about">
    <div class="container">
      <h3 class="title">About Me</h3>
      <div class="wrapper">
        <div class="row">
          <div
            class="col-lg-4 col-md-12 d-flex justify-content-lg-end justify-content-md-center justify-content-sm-center justify-content-center"
          >
            <div
              class="pic-container"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <img
                src="./../assets/Images/profile1.gif"
                alt="My Profile Picture"
              />
            </div>
          </div>
          <div class="col-lg-8 col-md-12 d-flex align-items-center">
            <div class="d-flex justify-content-center">
              <div
                class="brief-text"
                data-aos="fade-left"
                data-aos-duration="1000"
              >
                <p>
                  "I am Gopinath 21 years old. I Have 3 months of experience in
                  frontend development. And also have knowledge of Designing
                  dynamic and responsive web pages using HTML, CSS, Angular and
                  Typescript and prototypes using Adobe XD and Photoshop."
                </p>
                <div class="counting mt-3">
                  <div class="row">
                    <div class="col-6">
                      <div class="d-flex justify-content-center">
                        <div>
                          <h4>03+</h4>
                          <label class="ctn-lable ms-2"
                            >Months of <br />
                            experience</label
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="d-flex justify-content-center">
                        <div>
                          <h4>10+</h4>
                          <label class="ctn-lable ms-2"
                            >Projects <br />
                            Completed</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center mt-3">
                  <button class="btn-cv mt-2">
                    <a
                      href="./../assets/Document/Gopinath CV Web.pdf"
                      target=" _blank"
                      ><span>Download CV</span></a
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="skills">
    <div class="container">
      <h3 class="title">My Skills</h3>
      <div class="wrapper d-flex align-items-center">
        <div class="contents">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div data-aos="zoom-in" data-aos-duration="1000">
                    <h2 class="skill-title text-center mt-3">
                      <span style="color: #ff4a57"
                        ><i class="fa fa-code"></i
                      ></span>
                      Frontend Developer
                    </h2>
                    <ul>
                      <li>
                        <div class="w-100 mb-3">
                          <div class="d-flex justify-content-between">
                            <p>HTML</p>
                            <P>90%</P>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated progress-bg"
                              role="progressbar"
                              style="width: 90%"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="w-100 mb-3">
                          <div class="d-flex justify-content-between mt-3">
                            <p>CSS</p>
                            <P>70%</P>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated progress-bg"
                              role="progressbar"
                              style="width: 70%"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="w-100 mb-3">
                          <div class="d-flex justify-content-between mt-3">
                            <p>Angular</p>
                            <P>70%</P>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated progress-bg"
                              role="progressbar"
                              style="width: 70%"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="w-100 mb-3">
                          <div class="d-flex justify-content-between mt-3">
                            <p>JavaScript</p>
                            <P>50%</P>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated progress-bg"
                              role="progressbar"
                              style="width: 50%"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="w-100 mb-3">
                          <div class="d-flex justify-content-between mt-3">
                            <p>Typescript</p>
                            <P>60%</P>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated progress-bg"
                              role="progressbar"
                              style="width: 60%"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div data-aos="zoom-in" data-aos-duration="1000">
                    <h2 class="skill-title text-center mt-3">
                      <span style="color: #ff4a57"
                        ><i class="fa fa-server"></i
                      ></span>
                      Backend Developer
                    </h2>
                    <ul>
                      <li>
                        <div class="w-100 mb-3">
                          <div class="d-flex justify-content-between">
                            <p>Java</p>
                            <P>80%</P>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated progress-bg"
                              role="progressbar"
                              style="width: 80%"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="w-100 mb-3">
                          <div class="d-flex justify-content-between mt-3">
                            <p>SpringBoot</p>
                            <P>30%</P>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated progress-bg"
                              role="progressbar"
                              style="width: 30%"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="w-100 mb-3">
                          <div class="d-flex justify-content-between mt-3">
                            <p>MySQL</p>
                            <P>50%</P>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated progress-bg"
                              role="progressbar"
                              style="width: 50%"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <div data-aos="zoom-in" data-aos-duration="1000">
                    <h2 class="skill-title text-center mt-3">
                      <span style="color: #ff4a57"
                        ><i class="fa fa-paint-brush"></i
                      ></span>
                      Designing Tools
                    </h2>
                    <ul>
                      <li>
                        <div class="w-100 mb-3">
                          <div class="d-flex justify-content-between">
                            <p>Photoshop</p>
                            <P>80%</P>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated progress-bg"
                              role="progressbar"
                              style="width: 80%"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="w-100 mb-3">
                          <div class="d-flex justify-content-between mt-3">
                            <p>Illustrator</p>
                            <P>70%</P>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated progress-bg"
                              role="progressbar"
                              style="width: 70%"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="w-100 mb-3">
                          <div class="d-flex justify-content-between mt-3">
                            <p>Adobe XD</p>
                            <P>90%</P>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated progress-bg"
                              role="progressbar"
                              style="width: 90%"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="w-100 mb-3">
                          <div class="d-flex justify-content-between mt-3">
                            <p>Canva</p>
                            <P>70%</P>
                          </div>
                          <div class="progress">
                            <div
                              class="progress-bar progress-bar-striped progress-bar-animated progress-bg"
                              role="progressbar"
                              style="width: 70%"
                              aria-valuenow="100"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="service">
    <div class="container">
      <h3 class="title">I Can</h3>
      <div class="wrapper">
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          <div class="col" data-aos="zoom-in-down" data-aos-duration="1000">
            <div class="card text-center mx-auto">
              <div class="card-body d-flex">
                <div class="card-ico">
                  <svg
                    class="card-svg"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M10,13H3a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V14A1,1,0,0,0,10,13ZM9,20H4V15H9ZM21,2H14a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V3A1,1,0,0,0,21,2ZM20,9H15V4h5Zm1,4H14a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V14A1,1,0,0,0,21,13Zm-1,7H15V15h5ZM10,2H3A1,1,0,0,0,2,3v7a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V3A1,1,0,0,0,10,2ZM9,9H4V4H9Z"
                    />
                  </svg>
                </div>
              </div>
              <div class="py-2">
                <h5 class="card-title">UI/UX Design</h5>
                <span class="detail-modal-link"
                  ><a
                    href="https://drive.google.com/drive/folders/16h96-QaaM0DS2FqVHrGSLlA7lztgvReG?usp=sharing"
                    target="_blank"
                    >Details</a
                  ></span
                >
              </div>
            </div>
          </div>
          <div class="col" data-aos="zoom-in-down" data-aos-duration="1000">
            <div class="card text-center mx-auto">
              <div class="card-body d-flex">
                <div class="card-ico">
                  <svg
                    class="card-svg"
                    xmlns="http://www.w3.org/2000/svg"
                    data-name="Layer 1"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M6,6A2,2,0,0,1,8,4,1,1,0,0,0,8,2,4,4,0,0,0,4,6V9a2,2,0,0,1-2,2,1,1,0,0,0,0,2,2,2,0,0,1,2,2v3a4,4,0,0,0,4,4,1,1,0,0,0,0-2,2,2,0,0,1-2-2V15a4,4,0,0,0-1.38-3A4,4,0,0,0,6,9Zm16,5a2,2,0,0,1-2-2V6a4,4,0,0,0-4-4,1,1,0,0,0,0,2,2,2,0,0,1,2,2V9a4,4,0,0,0,1.38,3A4,4,0,0,0,18,15v3a2,2,0,0,1-2,2,1,1,0,0,0,0,2,4,4,0,0,0,4-4V15a2,2,0,0,1,2-2,1,1,0,0,0,0-2Z"
                    />
                  </svg>
                </div>
              </div>
              <div class="py-2">
                <h5 class="card-title">Frontend Design</h5>
                <span class="detail-modal-link"
                  ><a
                    href="https://drive.google.com/drive/folders/16p7_cLgZomysEc9-Xovi_WmMijtVx-tM"
                    target="_blank"
                    >Details</a
                  ></span
                >
              </div>
            </div>
          </div>
          <div class="col" data-aos="zoom-in-down" data-aos-duration="1000">
            <div class="card text-center mx-auto">
              <div class="card-body d-flex">
                <div class="card-ico">
                  <svg
                    class="card-svg"
                    xmlns="http://www.w3.org/2000/svg"
                    data-name="Layer 1"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M7.42,15.54a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41A1,1,0,0,0,7.42,15.54Zm0-8.49a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41A1,1,0,0,0,7.42,7.05Zm4.95,10a1,1,0,1,0,1,1A1,1,0,0,0,12.37,17Zm-6-6a1,1,0,1,0,1,1A1,1,0,0,0,6.37,11Zm6-6a1,1,0,1,0,1,1A1,1,0,0,0,12.37,5Zm3.54,2.05a1,1,0,1,0,1.41,0A1,1,0,0,0,15.91,7.05Zm6.3,0a11,11,0,1,0-7.85,15.74,3.87,3.87,0,0,0,2.5-1.65A4.2,4.2,0,0,0,17.47,18a5.65,5.65,0,0,1-.1-1,5,5,0,0,1,3-4.56,3.84,3.84,0,0,0,2.06-2.25A4,4,0,0,0,22.21,7.08Zm-1.7,2.44a1.9,1.9,0,0,1-1,1.09A7,7,0,0,0,15.37,17a7.3,7.3,0,0,0,.14,1.4,2.16,2.16,0,0,1-.31,1.65,1.79,1.79,0,0,1-1.21.8,8.72,8.72,0,0,1-1.62.15,9,9,0,0,1-9-9.28A9.05,9.05,0,0,1,11.85,3h.51a9,9,0,0,1,8.06,5A2,2,0,0,1,20.51,9.52ZM12.37,11a1,1,0,1,0,1,1A1,1,0,0,0,12.37,11Z"
                    />
                  </svg>
                </div>
              </div>
              <div class="py-2">
                <h5 class="card-title">Graphics Design</h5>
                <span class="detail-modal-link"
                  ><a
                    href="https://drive.google.com/drive/folders/1oHE5vwpehRb4P_SG4TxvYL_ZbU7jpovr?usp=sharing"
                    target="_blank"
                    >Details</a
                  ></span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="projects">
    <div class="container">
      <h3 class="title">My Projects</h3>
    </div>
    <div class="swip-pad">
      <div class="swiper-container" data-aos="zoom-in" data-aos-duration="1000">
        <swiper
          [cssMode]="true"
          [navigation]="arrow"
          [pagination]="true"
          [mousewheel]="true"
          [keyboard]="true"
          class="mySwiper"
        >
          <ng-template swiperSlide>
            <div class="container">
              <div class="wrapper">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="img-container mar-l">
                      <img
                        src="./../assets/Images/pinbilllg.png"
                        alt="Pinbill Projects 01"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="text-container mar-r">
                      <h5 class="mt-3">PinBill</h5>
                      <div class="para">
                        <p>
                          Pin Bill is a web app where you can add new bills,
                          edit existing bills and delete bills. Its clean UI
                          helps you to manage bills better.
                        </p>
                      </div>
                      <button class="btn-demo">
                        <span
                          ><a
                            href="https://drive.google.com/file/d/1EyX_d2mcLOHht_vTnAK1qD7xbZ7zBhsb/view?usp=sharing"
                            target="_blank"
                            >Demo</a
                          ></span
                        >
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </swiper>
      </div>
    </div>
  </section>
  <section id="contact">
    <div class="container pb-5">
      <h3 class="title">Contact Me</h3>
      <div class="wrapper">
        <div class="row my-3" data-aos="zoom-in" data-aos-duration="1000">
          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="detail-container mx-auto">
              <div class="cell">
                <h2>
                  <span><i class="fa fa-phone" aria-hidden="true"></i></span>
                  Call me
                </h2>
                <a href="tel:+918300762272">
                  <p class="ms-5">+91 8300762272</p>
                </a>
              </div>
              <div class="mail">
                <h2>
                  <span
                    ><i class="fa fa-envelope" aria-hidden="true"></i>
                  </span>
                  Mail
                </h2>
                <a href="mailto:p.gopinath.work@gmail.com">
                  <p class="ms-5">p.gopinath.work@gmail.com</p>
                </a>
              </div>
              <div class="location">
                <h2>
                  <span
                    ><i class="fa fa-map-marker" aria-hidden="true"></i>
                  </span>
                  Location
                </h2>
                <p class="ms-5">Nagapattinam, Tamil Nadu, 611105.</p>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="form-container mx-auto">
              <form action="https://formspree.io/f/xdoylvgn" method="POST">
                <input
                  class="mb-3"
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Name"
                  required
                />
                <br />
                <input
                  class="mb-3"
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email Id"
                  required
                /><br />
                <textarea
                  class="mb-3"
                  name="msg"
                  id="msg"
                  rows="3"
                  placeholder="Message"
                  required
                ></textarea>
                <br />
                <button class="btn-send" type="submit">
                  <span>Send</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="footer">
    <div class="container">
      <div class="gotop">
        <span>
          <a href="#home"
            ><i class="fa fa-angle-double-up" aria-hidden="true"></i
          ></a>
        </span>
      </div>
      <div class="wrapper">
        <span>
          <a href="https://www.instagram.com/h.tanipog/" target="_blank"
            ><i class="fa fa-instagram" aria-hidden="true"></i
          ></a>
        </span>
        <span>
          <a href="https://codepen.io/gopi-p" target="_blank"
            ><i class="fa fa-codepen" aria-hidden="true"></i
          ></a>
        </span>
        <span>
          <a href="https://github.com/Gopi-p" target="_blank"
            ><i class="fa fa-github" aria-hidden="true"></i
          ></a>
        </span>
        <span>
          <a
            href="https://www.linkedin.com/in/gopi-p-1b8342192/"
            target="_blank"
            ><i class="fa fa-linkedin-square" aria-hidden="true"></i
          ></a>
        </span>
        <span>
          <a href="https://www.youtube.com/c/Gopicreation" target="_blank"
            ><i class="fa fa-youtube-play" aria-hidden="true"></i
          ></a>
        </span>
      </div>
    </div>
    <div class="cpy">
      <p>Smartfolio | © Designed by Gopinath</p>
    </div>
  </section>
</section>
